import React from "react";

function Home() {
  return (
    <section className="home">
      {/* Imagen debajo del navbar */}
      <div className="home-image-container">
        <img src="/Grupo.jpg" alt="Bienvenida" className="home-image" />
      </div>
      {/* Contenido principal */}
      <div className="home-content box has-text-centered">
        <h1 className="title is-1 mt-3">Bienvenido!</h1>
        <h1 className="fancy-text">Somos un pueblo de discípulos en misión</h1>
      </div>

      <section className="hero is-primary is-bold custom-hero">
        <div className="hero-body">
          <div className="columns is-vcentered">
            {/* Imagen */}
            <div className="column is-three-quarters">
              <img src="/Tiles_1.png" alt="Imagen Hero" className="image" />
            </div>

            <div className="column is-half-mobile is-one-third-tablet is-one-quarter-desktop has-text-centered">
              <h3 className="title is-3">Caminando de la mano del Señor</h3>

              <div className="subtitle-container">
                <p className="subtitle is-5">
                  <span className="highlight-text">
                    Viviendo la unidad en Cristo, cumpliendo una misión
                    evangelizadora y de servicio.
                  </span>
                </p>
              </div>

              <button className="button is-link is-medium mt-3 is-hidden-mobile">
                Nuestro Llamado
              </button>
              <button className="button is-link is-small mt-3 is-hidden-tablet">
                Nuestro Llamado
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Producto Estrella */}
      <section className="discipulado-section">
        <div className="content-container">
          <img
            src="/Portada2_.png"
            alt="Programa de Discipulado"
            className="background-image"
          />

          <div className="text-content">
            <h3 className="title is-3 has-text-white text-overlay">
              Somos Testimonio de unidad
            </h3>
            <p className="subtitle is-5 has-text-white mt-3">
              Tenemos nuestros orígenes en la renovación carismática.
            </p>
            <button className="button is-success is-medium mt-2 is-pulled-right">
              Nuestra Historia
            </button>
          </div>
        </div>
      </section>
      {/* Galería */}
      <section className="section">
        <div className="columns">
          {["/Asamblea_2.jpg", "/Asamblea_1.jpg", "/Consejo.jpg"].map(
            (img, index) => (
              <div className="column is-one-third" key={index}>
                <figure className="image">
                  <img
                    src={img}
                    alt="Galería"
                    className="rounded"
                    style={{ width: "100%", height: "auto" }}
                  />
                </figure>
              </div>
            )
          )}
        </div>
        <div className="has-text-centered mt-4">
          <button className="button is-link is-focused is-medium">
            Nuestros Valores
          </button>
        </div>
      </section>

      {/* Misión y Visión */}
      <section className="section has-text-centered">
        <h2 className="title is-2 mb-4">Nuestra Misión y Proyección</h2>
        <p className="subtitle is-5">
          El centro de nuestra misión puede ser descrito como la edificación de
          un baluarte, esto es predicar el evangelio y edificar comunidad
          Cristiana. Por lo tanto mantenemos activamente un enfoque hacia la
          evangelización que atrae a otros a nuestra vida. Nuestros miembros
          están comprometidos con nuestra misión y se involucran en ella local,
          regional e internacionalmente.
        </p>
        <p className="subtitle is-5">
          Estamos llamados a vivir, trabajar y esforzarnos, por el poder del
          Espíritu Santo, para que otros puedan tener verdadera vida en Cristo,
          ahora y por siempre. Estas cosas las hacemos individualmente, tanto en
          nuestra vida cotidiana como sirviendo en la comunidad o en sus
          programas. Estas cosas las hacemos comunitariamente, abriendo nuestra
          vida a otros, manteniendo programas de proyección, y ayudando a
          construir nuevas comunidades.
        </p>
      </section>

      <section className="discipulado-section">
        <div className="content-container">
          <img
            src="/ReunionCoordinadores.jpg"
            alt="Programa de Discipulado"
            className="background-image-coordinadores"
          />
        </div>
      </section>
    </section>
  );
}

export default Home;
